export const USER_INFO_RECEIVED = "USER_INFO_RECEIVED";
export const CLINIC_INFO_RECEIVED = "CLINIC_INFO_RECEIVED";
export const ADDRESS_LIST_RETERIEVED = "ADDRESS_LIST_RETERIEVED";
export const PRACTITIONER_COMMISSION_RETERIEVED =
  "PRACTITIONER_COMMISSION_RETERIEVED";
export const CARD_LIST_RETRIEVED = "CARD_LIST_RETRIEVED";
export const PATIENT_PROFILE_RECEIVED = "PATIENT_PROFILE_RECEIVED";
export const PRACTITIONER_PROFILE_RECEIVED = "PRACTITIONER_PROFILE_RECEIVED";
export const FULLSCRIPT_TREATMENTPLAN_RETRIEVED =
  "FULLSCRIPT_TREATMENTPLAN_RETRIEVED";
export const SHIPPING_PRICE_RETRIEVED = "SHIPPING_PRICE_RETRIEVED";
export const QR_CODE_URL_RECEIVED = "QR_CODE_URL_RECEIVED";
